import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import { i18nReducer } from 'react-redux-i18n'

/** NEW REDUCERS */
import conversationAddress from 'redux_new/conversations/conversationAddress/reducers'
import conversationPassengers from 'redux_new/conversations/conversationPassengers/reducers'
import nxAuthToken from 'redux_new/nxAuthToken/reducers'
import modules from '../modules/reducers'
import temporaryRecord from '../temporaryRecord/reducers'
import flowErrors from '../flowErrors/reducers'
import messages from '../messages/reducers'
import mnemonics from '../mnemonics/reducers'
import currentNotifications from '../currentNotifications/reducers'
import centers from '../centers/reducers'
import resources from '../resources/reducers'
import nauta from '../nauta/reducers'
import poolLists from '../poolLists/reducers'
import settings from '../settings/reducers'
import outbound from '../outbound/reducer'
import channels from '../channels/reducers'
import categories from '../categories/reducers'
import smartchatHeader from '../smartchat/header/reducer'
import smartchatDetails from '../smartchat/details/reducer'
import smartchatAlternatives from '../smartchat/alternatives/reducer'
import inchat from '../inchat/reducers'
import searchEngine from '../searchEngine/reducer'
import currentPlan from '../currentPlan/reducers'

import storage from 'redux-persist/es/storage'
import { purgeStoredState } from 'redux-persist'

/* REDUCERS */
import user from './user'
import roles from './roles'
import sidebar from './sidebar'

// Conversations
import conversations from './conversations'
import conversationSearchReducer from './cv_search'
import conversationUsersReducer from './cv_users'
import conversationListsReducer from './cv_lists'
import conversationUsersListsReducer from './cv_usersLists'
import tabs from './tabs'
import notifications from './notifications'

// Company
import companiesReducer from './companies'
import brandsReducer from './brands'
import delegationsReducer from './delegations'
import assignedUsersReducer from './assignedUsers'
import assignationsReducer from './assignations'
import companyDashusersReducer from './operators'

// Booking
import bookingSearchReducer from './searchBooking'
import bookings from '../bookings/reducer'
import dashNotifications from '../dashNotifications/reducers'

import operatorAutoDisabled from '../operatorAutoDisabled/reducers'

import rolePermissions from 'redux/rolePermissions/reducers'

import { showNotification } from './showNotification'

// WALL
import wall from './wall'

// Marketing
import marketing from './marketing'

// Pools
import pools from '../pools/reducer'

// Config to save reducers data in storage with redux-persist
const rootPersistConfig = {
  key: 'dash-nixi1',
  storage,
  whitelist: [
    'user',
    'conversations',
    'searchBooking',
    'tabs',
    'cv_search',
    // New
    'userTabs',
    'nxAuthToken',
    'temporaryRecord',
    'inchat', // persistir datos de inchat
  ],
}

const appReducer = combineReducers({
  user,
  tabs,
  conversations,
  roles,
  notifications,
  i18n: i18nReducer,
  cv_search: conversationSearchReducer,
  cv_users: conversationUsersReducer,
  assignedUsers: assignedUsersReducer,
  cv_lists: conversationListsReducer,
  cv_usersLists: conversationUsersListsReducer,
  brands: brandsReducer,
  delegations: delegationsReducer,
  companies: companiesReducer,
  operators: companyDashusersReducer,
  assignations: assignationsReducer,
  searchBooking: bookingSearchReducer,
  sidebar,
  showNotification,
  // New
  conversationAddress,
  conversationPassengers,
  nxAuthToken,
  wall,
  marketing,
  modules,
  temporaryRecord,
  flowErrors,
  messages,
  mnemonics,
  currentNotifications,
  centers,
  resources,
  nauta,
  poolLists,
  settings,
  outbound,
  channels,
  categories,
  smartchatHeader,
  smartchatDetails,
  smartchatAlternatives,
  bookings,
  dashNotifications,
  inchat,
  searchEngine,
  operatorAutoDisabled,
  pools,
  rolePermissions,
  currentPlan
})

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    // unmount the support chat

    // for all keys defined in your persistConfig(s)
    // storage.removeItem('persist:dash-nixi1')
    purgeStoredState(rootPersistConfig)

    // keep the lang reducer
    state = { i18n: state.i18n }

    return appReducer(state, action)
  } else {
    return appReducer(state, action)
  }
}

export default persistReducer(rootPersistConfig, rootReducer)
